import React, { useRef } from 'react';
import axios from 'axios';
import * as rsuite from 'rsuite'
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { Link, useNavigate } from "react-router-dom";
import { isMobile } from 'react-device-detect';

import { FaHome } from "react-icons/fa";
import { MdOutlineMenu } from "react-icons/md";
import { MdSpaceDashboard } from "react-icons/md";
import { MdOutlineSupportAgent } from "react-icons/md";
import { MdSearch } from "react-icons/md";
import { FaUsers } from "react-icons/fa6";
import { FaUserClock } from "react-icons/fa6";
import { FaUser } from "react-icons/fa";
import { FaTasks } from "react-icons/fa";
import { FaCheckDouble } from "react-icons/fa6";
import { GoProjectSymlink } from "react-icons/go";
import { CgProfile } from "react-icons/cg";
import * as General from '../../General/General';
import * as Enum from '../../General/Enum';
import { BiSolidCategory } from "react-icons/bi";
import { SiReadthedocs } from "react-icons/si";
import { MdOutlineNewReleases } from "react-icons/md";
import { HiOutlineDocumentReport } from "react-icons/hi";
import { HiOutlineChatAlt2 } from "react-icons/hi";
import "bootstrap/dist/css/bootstrap.rtl.min.css";
import "rsuite/dist/rsuite-rtl.min.css";

const Shared = ({ children, pageTitle }) => {

    //#region Constants
    let navigate = useNavigate();
    const PopupRef = useRef();
    //--> روی وب منو جمع شده است (فقط آیکن)، روی موبایل کاملا بسته است
    const [Collapse, setCollapse] = React.useState(true);

    //--> روی موبایل عرض حالت جمع صفر است، پس دکمه همبرگری داخل خود منو
    //--> دیده نمی شود و باید از نوار بالای صفحه باز شود
    const CollapsedWidth = isMobile ? "0px" : "70px";

    //--> بعد از انتخاب یک گزینه، منوی موبایل باید دوباره بسته شود
    //--> وگرنه روی صفحه کوچک جلوی محتوا می ماند
    const CloseOnMobile = () => {
        if (isMobile) {
            setCollapse(true);
        }
    }

    //--> شمار گفتگوهای باز، کنار نام کاربر در نوار بالا.
    //--> با هر جابجایی بین صفحه ها این قاب دوباره سوار می شود، پس عدد تازه می ماند.
    const [ChatCount, setChatCount] = React.useState(0);
    //#endregion Constants


    // #region Methods 

    const LogOut = () => {
        var requestOptions = {
            method: "Post",
            credentials: "include",
        };

        fetch(General.ApiRoute() + "/User/Logout", requestOptions)
            .then((result) => {

                navigate("/");
            })
            .catch((error) => {

                General.ShowMsg(Enum.MsgType.error, General.UnkownException(error));
            })
    };

    const BindChatCount = React.useCallback(() => {
        axios({
            method: "Get",
            url: General.ApiRoute() + "/TaskConversation/OpenCount",
            headers: { ApiKey: process.env.REACT_APP_APIKEY },
            withCredentials: true
        })
            .then(function (res) {
                //--> سرویس یک عدد خام بر می گرداند؛ شکل شیئی هم پذیرفته می شود
                //--> تا اگر روزی قرارداد عوض شد، نشان بی صدا صفر نشود
                const value = res.data && typeof res.data === 'object'
                    ? res.data.count
                    : res.data;
                setChatCount(value ? Number(value) : 0);
            })
            //--> یک نشان تزئینی نباید صفحه را بخواباند
            .catch(() => { })
    }, []);

    React.useEffect(() => {
        BindChatCount();

        //--> عدد فقط با سوار شدن این قاب خوانده می شد، پس بعد از بستن یا
        //--> ساختن گفتگو بیات می ماند. با برگشتن به پنجره دوباره خوانده می شود.
        window.addEventListener('focus', BindChatCount);
        //--> و هر صفحه ای که خودش را بازسازی می کند (داشبورد، فهرست گفتگوها)
        //--> این رویداد را می فرستد تا نشان هم همان لحظه تازه شود
        window.addEventListener(General.ChatCountEvent, BindChatCount);
        return () => {
            window.removeEventListener('focus', BindChatCount);
            window.removeEventListener(General.ChatCountEvent, BindChatCount);
        };
    }, [BindChatCount])

    // #endregion
    return (
        <div style={{ display: 'flex', height: '100vh', direction: 'rtl' }}>
            <Sidebar rtl collapsed={Collapse} collapsedWidth={CollapsedWidth}>
                <Menu onClick={CloseOnMobile}>
                    <MenuItem icon={<MdOutlineMenu size={25} />} onClick={() => setCollapse(!Collapse)}></MenuItem>
                    <Link to="/home">
                        <MenuItem icon={<MdSpaceDashboard size={25} />}> داشبورد</MenuItem>
                    </Link>
                    <Link to="/User">
                        <MenuItem icon={<FaUser size={25} />}> کـــاربران</MenuItem>
                    </Link>
                    <Link to="/Project">
                        <MenuItem icon={<GoProjectSymlink size={25} />}> پروژه</MenuItem>
                    </Link>
                    <Link to="/Category">
                        <MenuItem icon={<BiSolidCategory size={25} />}> دسته بندی پروژه</MenuItem>
                    </Link>
                    <Link to="/Company">
                        <MenuItem icon={<FaUsers size={25} />}>مشتری</MenuItem>
                    </Link>
                    <Link to="/AgentIndex">
                        <MenuItem icon={<MdOutlineSupportAgent size={25} />}> تیکت ها</MenuItem>
                    </Link>
                    {
                        //--> فقط مدیر: تیکت های همه شرکت ها، فارغ از اینکه چه
                        //--> کسی رویشان کار کرده. کارتابل بالا شخصی است.
                        localStorage.getItem("Permission") === "0" ?
                            <Link to="/Tickets">
                                <MenuItem icon={<MdSearch size={25} />}> جستجوی تیکت ها</MenuItem>
                            </Link>
                            :
                            null
                    }
                    <Link to="/Topic">
                        <MenuItem icon={<SiReadthedocs size={25} />}> اسناد راهنما</MenuItem>
                    </Link>

                    <Link to="/ProjectVersion">
                        <MenuItem icon={<MdOutlineNewReleases size={25} />}> انتشار نسخه</MenuItem>
                    </Link>


                    {
                        localStorage.getItem("Permission") === "0" ?
                            <Link to="/Task">
                                <MenuItem icon={<FaTasks size={25} />}> وظایف تیم</MenuItem>
                            </Link>
                            :
                            null
                    }
                    {
                        localStorage.getItem("Permission") === "0" ?
                            <Link to="/TaskApproval">
                                <MenuItem icon={<FaCheckDouble size={25} />}> تایید وظایف</MenuItem>
                            </Link>
                            :
                            null
                    }
                    {
                        //--> فقط مدیر: گزارش کار همه اعضای تیم
                        localStorage.getItem("Permission") === "0" ?
                            <Link to="/ReportActivity">
                                <MenuItem icon={<HiOutlineDocumentReport size={25} />}> گزارش کار</MenuItem>
                            </Link>
                            :
                            null
                    }
                    <Link to="/MyTasks">
                        <MenuItem icon={<FaUserClock size={25} />}> وظایف من</MenuItem>
                    </Link>
                    <Link to="/Conversations">
                        <MenuItem icon={<HiOutlineChatAlt2 size={25} />}> گفتگوها</MenuItem>
                    </Link>
                </Menu>
            </Sidebar>
            {/* روی موبایل حاشیه ها روی هم انباشته می شدند - این لایه، main، و
                پنل ها هر کدام حاشیه خودشان را داشتند و روی صفحه باریک بخش
                بزرگی از عرض از دست می رفت. اینجا همه شان جمع می شوند و
                رسیدگی به حاشیه داخلی پنل ها در Style.css انجام می شود. */}
            {/* ستون راست: نوار عنوان بالا ثابت می ماند و فقط محتوا اسکرول
                می خورد. قبلا کل ستون با هم اسکرول می شد و عنوان از بالای
                صفحه بیرون می رفت. overflow: hidden لازم است تا فرزند
                flex بتواند اسکرول خودش را داشته باشد. */}
            <div className={isMobile ? 'AppContent is-mobile' : 'AppContent'} style={{
                flex: 1,
                height: '100vh',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                padding: isMobile ? '0.25rem' : '0.75rem'
            }}>

                {/* روی وب هم ps-5/pe-5 برداشته شد: چهل و هشت پیکسل در هر طرف،
                    روی حاشیه های دیگر، عرض مفید جدول ها را کم می کرد */}
                <main className={isMobile ? 'w-100 AppMain' : 'w-100 px-2 AppMain'}
                    style={{ display: 'flex', flexDirection: 'column', flex: '1 1 auto', minHeight: 0 }}>

                    {/* inline است چون rs-container خودش flex: auto دارد و CSS
                        رsuite بعد از Style.css تزریق می شود؛ با specificity
                        برابر، قاعده کتابخانه برنده می شد و نوار عنوان کش می آمد */}
                    <rsuite.Container className='AppTitleBar' style={{ flex: '0 0 auto' }}>
                        <rsuite.Row>

                            <rsuite.Col xs={24}>
                                <rsuite.Panel className={isMobile ? 'p-0 mb-1 mt-1' : 'p-0 mb-2 mt-1'}>
                                    <rsuite.Stack justifyContent='space-between'>

                                        {/* عنوان با دکمه منو یک گروه است تا با space-between
                                            سمت راست بنشیند. اگر جدا باشد، عنصر وسطیِ سه تایی
                                            می شود و وسط صفحه می افتد. */}
                                        <rsuite.Stack spacing={10}>
                                            {
                                                //--> فقط روی موبایل: تنها راه باز کردن منوی کاملا بسته
                                                isMobile ?
                                                    <rsuite.IconButton
                                                        appearance="subtle"
                                                        icon={<MdOutlineMenu size={22} />}
                                                        onClick={() => setCollapse(!Collapse)}
                                                    />
                                                    :
                                                    null
                                            }
                                            <b>{pageTitle}</b>
                                        </rsuite.Stack>

                                        <rsuite.Stack spacing={14}>
                                        {/* نشان گفتگوهای منتظر پاسخ - کنار نام کاربر،
                                            چون نوار بالا همیشه دیده می شود ولی منوی
                                            کناری معمولا جمع است.
                                            عدد فقط آنهایی است که نوبت خود اوست؛
                                            گفتگویی که جوابش را داده کاری برای او ندارد */}
                                        <span className='HandCursor' title="گفتگوهای منتظر پاسخ شما"
                                            onClick={() => navigate("/Conversations")}>
                                            {
                                                ChatCount > 0 ?
                                                    <rsuite.Badge content={ChatCount}>
                                                        <HiOutlineChatAlt2 size={22} />
                                                    </rsuite.Badge>
                                                    :
                                                    <HiOutlineChatAlt2 size={22} />
                                            }
                                        </span>

                                        <rsuite.Whisper
                                            placement="bottomStart"
                                            controlId="control-id-with-dropdown"
                                            trigger="click"
                                            ref={PopupRef}
                                            speaker={
                                                <rsuite.Popover full>
                                                    <rsuite.Dropdown.Menu >
                                                        <rsuite.Dropdown.Item>تغییر کلمه عبور</rsuite.Dropdown.Item>
                                                        <rsuite.Dropdown.Item onClick={LogOut} >خـــروج</rsuite.Dropdown.Item>
                                                    </rsuite.Dropdown.Menu>
                                                </rsuite.Popover>
                                            }
                                        >
                                            <div className='text-dark HandCursor'>
                                                <CgProfile size={20} className='me-2' />{localStorage.getItem("FirstName") + ' ' + localStorage.getItem("LastName")}
                                            </div>
                                        </rsuite.Whisper>
                                        </rsuite.Stack>
                                    </rsuite.Stack>
                                </rsuite.Panel>
                            </rsuite.Col>

                        </rsuite.Row>
                    </rsuite.Container>

                    {/* تنها بخشی که اسکرول می خورد */}
                    {/* overflowX صریحا hidden است: در CSS اگر یک محور visible بماند
                        و محور دیگر نه، visible خودش auto می شود و اسکرول افقی
                        ناخواسته ظاهر می شود. */}
                    <div className='AppScroll'
                        style={{ flex: '1 1 auto', minHeight: 0, overflowY: 'auto', overflowX: 'hidden' }}>
                        <rsuite.Container>
                            <rsuite.Row>
                                <rsuite.Col xs={24} >
                                    <rsuite.Panel className={isMobile ? 'w-100 bg-white p-0' : 'w-100 bg-white p-1'}>
                                        {children}
                                    </rsuite.Panel>

                                </rsuite.Col>
                            </rsuite.Row>
                        </rsuite.Container>
                    </div>

                </main>
            </div>
        </div >

    );
}

export default Shared;